import { render, staticRenderFns } from "./noteBook.vue?vue&type=template&id=1be460ba&scoped=true"
import script from "./noteBook.vue?vue&type=script&lang=js"
export * from "./noteBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be460ba",
  null
  
)

export default component.exports